export default {"src":"/_next/static/media/kerrits.ba25cecc.svg","height":80,"width":184,"blurWidth":0,"blurHeight":0};